import groq from 'groq'

import { videoAsset } from './videoAsset.js'
import { imageAsset } from './imageAsset.js'

export function mediaAsset() {
	return groq`
    {
        _type == 'videoAsset' => {
            ...${videoAsset()}
        },
        _type == 'imageAsset' => {
            ...${imageAsset()}
        }
    }
`
}
